// extracted by mini-css-extract-plugin
export default {"button":"Styles_button__c8GVs"};